import React from 'react';
import PropTypes from 'prop-types';

import DialogWrapper from 'shared/components/layout/DialogWrapper';

import ClinicalDecisionSupportForm from './ClinicalDecisionSupportForm';

const ClinicalDecisionSupportAdd = ({ onSubmit, onCancel }) => (
  <DialogWrapper title="New Resource">
    <ClinicalDecisionSupportForm
      onCancel={onCancel}
      onSubmit={onSubmit}
      defaultValues={{ title: '', description: '', link: '' }}
    />
  </DialogWrapper>
);

ClinicalDecisionSupportAdd.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ClinicalDecisionSupportAdd;
